<template>
  <div class="">
    <div id="container"></div>
  </div>
</template>
<script>
import { heatmapData } from './heatmapData'
export default {
  mounted() {
    // 延迟加载，防止出现AMap not defined
    setTimeout(() => {
      this.initMap()
      this.createHeatMap()
    }, 1000)
  },
  beforeDestroy() {
    this.map && this.map.destroy()
  },
  data() {
    return {
      map: null,
      heatmap: null,
    }
  },
  components: {},
  methods: {
    initMap() {
      this.map = new AMap.Map('container', {
        resizeEnable: true,
        center: [116.480983, 39.989628],
        zoom: 11,
        mapStyle: 'amap://styles/grey', // 极夜蓝
      })
    },
    //判断浏览区是否支持canvas
    isSupportCanvas() {
      let elem = document.createElement('canvas')
      return !!(elem.getContext && elem.getContext('2d'))
    },
    createHeatMap() {
      if (!this.isSupportCanvas()) {
        return this.$msg.error('热力图仅对支持canvas的浏览器适用,您所使用的浏览器不能使用热力图功能,请换个浏览器试试。')
      }
      let __this = this
      this.map.plugin(['AMap.Heatmap'], function () {
        //初始化heatmap对象
        __this.heatmap = new AMap.Heatmap(__this.map, {
          // visible: false,
          radius: 25, //给定半径
          opacity: [0, 0.8],
          gradient: {
            0.5: 'blue',
            0.65: 'rgb(117,211,248)',
            0.7: 'rgb(0, 255, 0)',
            0.9: '#ffea00',
            1.0: 'red',
          },
        })
        //设置数据集：该数据为北京部分“公园”数据
        __this.heatmap.setDataSet({
          data: heatmapData,
          max: 100,
        })

      })
    },
  },
}
</script>
<style lang="scss" scoped>
#container {
  margin: 10px 0 0;
  padding: 0;
  width: 100%;
  height: 690px;
}
.input-card .btn {
  margin-right: 1.2rem;
  width: 9rem;
}
</style>